module.exports = __webpack_public_path__ + "img/desktop-elbow-3_74x72.deac2c30.png";